export const editStep = (props, step, previousStep) => {
  const {
    updateAppointmentDetail,
    goToStep,
    goBackToStep,
    toggleControl,
    reloadSteps
  } = props;

  updateAppointmentDetail(step, "");
  goBackToStep(previousStep);
  setTimeout(() => toggleControl(step, true), 500);

  goToStep(step);
  reloadSteps();
};



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/FormFields/formHelpers.js